module.exports = __webpack_public_path__ + "assets/img/creationMng_(33).28fe9721.png";